import * as React from 'react';
import ModuleData from './ModuleData';
import { WebViewProps } from '../interfaces';
import ModulTable from '../ModulTabelle';

export interface TableWebViewProps extends WebViewProps<ModuleData>, React.Props<TableWebView> {
    module: ModulTable;
}

export default class TableWebView extends React.Component<TableWebViewProps, {}> {

    private tableContainer: HTMLElement;

    componentDidMount() {
        this.props.module.initCKEditor(this.tableContainer);
    }

    render() {
        return (
            <div id={"table_" + this.props.module.moduleId}>
                <div
                    ref={(tableContainer) => this.tableContainer = tableContainer}
                    className="tableContainer"
                    id={"table_" + this.props.module.moduleId + "_container"}
                    dangerouslySetInnerHTML={{ __html: this.props.payload.text }}
                >
                </div>
                <div className="c"></div>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/table/WebView.tsx
 **/